import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Body} from 'shells/typography/body';

import styles from './empty-tab.module.css';

type Props = {
    title: string;
    subtitle: string;
    icon?: React.ComponentType<any>;
};

export function EmptyTab(props: Props) {
    const Icon = props.icon;

    return (
        <div className='flex align-center justify-center text-align-center full-width full-height'>
            <div className={styles.content}>
                {Icon ? <Icon size={62} alignCenter={true} fill={colors.greyXlt} /> : undefined}
                <Body size='xlarge' color='light' isBold={true}>
                    {props.title}
                </Body>
                <Body size='large' color='light'>
                    {props.subtitle}
                </Body>
            </div>
        </div>
    );
}
